/**
 * @file Reports Dropdown
 */

import modulo from 'just-modulo';

/**
 * Reports Dropdown component
 */
const vReportsDropdown = () => {
	const reportsDropdown = document.querySelectorAll( '.v-reports-dropdown' );

	if ( ! reportsDropdown.length ) {
		return;
	}

	[ ...reportsDropdown ].forEach( ( dd ) => {
		// const costTarget  = document.querySelector( `#${ dd.getAttribute( 'data-cost-target-id' ) }` );
		const trigger     = dd.querySelector( '.v-reports-dropdown__trigger' );
		const triggerText = trigger.querySelector( '.v-reports-dropdown__trigger-text' );
		const list        = dd.querySelector( '.v-reports-dropdown__list' );
		// const items       = dd.querySelectorAll( '.v-reports-dropdown__item' );
		const options     = dd.querySelectorAll( '.v-reports-dropdown__opt-btn' );

		/**
		 * Toggle the dropdown
		 *
		 * @param {Event} e - The event object
		 * @param {boolean} forceAction - Forces the action to open or close
		 * @param {boolean} preventDefault - Whether to prevent the default action
		 */
		const toggleHandler = ( e, forceAction = null, preventDefault = true ) => {
			if ( preventDefault ) {
				e.preventDefault();
			}

			if ( forceAction === null ) {
				forceAction = ! dd.classList.contains( 'open' );
			}

			dd.classList.toggle( 'open', forceAction );

			if ( dd.classList.contains( 'open' ) ) {
				[ ...options ][ 0 ].focus();
			}
		};

		/**
		 * Select an option
		 *
		 * @param {HTMLButtonElement} option - The option to select
		 */
		const selectOption = ( option ) => {
			// e.preventDefault();

			list.setAttribute( 'aria-activedescendant', option.id );
			triggerText.textContent = option.textContent;

			// dispatch event to update the cost
			const event = new CustomEvent( 'vReportsDropdownChange', {
				detail: {
					cost:   option.getAttribute( 'data-cost' ),
					label:  option.getAttribute( 'data-label' ),
					target: trigger,
				},
			} );
			document.dispatchEvent( event );

			dd.classList.remove( 'open' );
			trigger.focus();
		};

		/**
		 * Handle keyboard events
		 *
		 * @param {Event} e - The event object
		 */
		const keyboardEventsHandler = ( e ) => {
			// close the dropdown if the user hits escape
			if ( e.key === 'Escape' ) {
				toggleHandler( e, false, false );
			}

			// if the dropdown is open, allow the user to navigate the options with the arrow keys
			if ( dd.classList.contains( 'open' ) && dd.contains( trigger.ownerDocument.activeElement ) ) {
				let dir            = null;
				if ( e.key === 'ArrowUp' ) {
					e.preventDefault();
					dir = 'left';
				} else if ( e.key === 'ArrowDown' ) {
					e.preventDefault();
					dir = 'right';
				}

				if ( dir ) {
					const currentIndex = [ ...options ].indexOf( trigger.ownerDocument.activeElement );
					const nextIndex    = modulo( currentIndex + ( dir === 'left' ? -1 : 1 ), options.length );
					const newOption    = [ ...options ][ nextIndex ];

					newOption.focus();
				}

				if ( e.key === 'Enter' && dd.contains( trigger.ownerDocument.activeElement ) ) {
					e.preventDefault();
					selectOption( trigger.ownerDocument.activeElement );
					trigger.focus();
				}
			}

			// if the dropdown is closed, allow the user to open it with the arrow or space keys
			if ( ! dd.classList.contains( 'open' ) && trigger.contains( trigger.ownerDocument.activeElement ) ) {
				if ( e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === ' ' ) {
					toggleHandler( e, true, false );
				}
			}
		};

		// Attach event listeners
		[ ...options ].forEach( ( option ) => {
			option.addEventListener( 'click', ( e ) => {
				e.preventDefault();

				selectOption( option );
			} );
		} );

		trigger.addEventListener( 'click', toggleHandler );
		trigger.addEventListener( 'touchstart', toggleHandler );

		document.addEventListener( 'click', ( e ) => {
			const { target } = e;

			if ( dd.contains( target ) ) {
				return;
			}

			toggleHandler( e, false, false );
		} );

		document.addEventListener( 'keydown', keyboardEventsHandler );
	} );
};

export default vReportsDropdown;
